import React, {  useState } from 'react'
import { Card, Grid,  Typography, Stack,  DialogTitle, IconButton, Box } from '@mui/material'
import MDButton from 'components/MDButton'
import { useNavigate } from 'react-router-dom';
import { openSnackbar } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { slotRollBackData } from '../../redux/slices/hyperwolf/settings';

export default function SlotRollBack({ closeModal }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { loading: isBtnLoading = false } = useSelector(state => state?.metrc)
    const { modalData } = useSelector(state => state.modal);
    const { data, dataHandler = () => { } } = modalData || {};

    const submitHandler = () => {
        dispatch(slotRollBackData(data?._id))
            .unwrap()
            .then(res => {
                closeModal()
                dataHandler();
                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });

    }

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }


    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <Box sx={{ p: 0, mb: 4, px: 0 }}>
                <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between' style={{ padding: '0' }}>
                    Confirm Rollback
                    <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                        <CloseIcon fontSize='medium' />
                    </IconButton>
                </DialogTitle>
                <Typography variant='body2' fontWeight="500" color="#656575">Are you sure you want to proceed?</Typography>
            </Box>

            <Grid container alignItems='center' spacing={{ xs: 3, md: 3 }} mb={2} mt={4}>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">Day</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.day ? data?.newChanges?.day : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">Time Slot</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.timeSlot ? data?.newChanges?.timeSlot : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">Action Type</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.actionType ? data?.newChanges?.actionType : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">Field Changed</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.fieldChanged ? data?.newChanges?.fieldChanged : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">Old Value</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.oldValue ? data?.newChanges?.oldValue : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">New Value</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.newValue ? data?.newChanges?.newValue : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Typography variant='body2' fontWeight="500" color="#656575">Will be restored to</Typography>
                    <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">
                        {data?.newChanges?.oldValue ? data?.newChanges?.oldValue : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mt={2}>
                        <MDButton sx={{ minWidth: '205px' }} type='button' variant='contained' color='primary' onClick={() => submitHandler()} disabled={isBtnLoading} loading={isBtnLoading}>
                            Confirm Rollback
                        </MDButton>
                        <MDButton sx={{ minWidth: '150px' }} type='button' variant='outlined' color='dark' className='dark-outlined-btn' onClick={() => closeModal()}>
                            Cancel
                        </MDButton>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}